
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { PermissionItemProps, PermissionTreeItemProps } from ".";
import { loading, index, tree } from "store/permission";

interface ApiPermissionInputProps {
    page: number;
    pageSize: number;
}

type ApiPermissionOutputProps = OutputBaseProps<{ list: PermissionItemProps[]; pagination?: PaginationProps; }>;

export const apiPermissionIndex = async (data: ApiPermissionInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPermissionOutputProps>("/api/permissions", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

type ApiPermissionTreeOutputProps = OutputBaseProps<{ list: PermissionTreeItemProps[]; }>

export const apiPermissionTree = async () => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPermissionTreeOutputProps>("/api/permission/tree", {}))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(tree({ data: res.data.list }));
    }
    return res;
};